import { BankingProductsByTypeParams, BankingProductsByTypeResponse } from '@repo/accounts-types'
import { ApiResponse, Service } from '@repo/core'
import { BankingProductType } from '@repo/shared-types'
import { AxiosRequestConfig } from 'axios'

const productTypeUrlMap: Partial<Record<BankingProductType, string>> = {
  CASH: 'cash-accounts',
  CREDIT_CARD: 'credit-cards',
  DEBIT_CARD: 'debit-cards',
  CREDIT: 'credits',
  DEPOSIT: 'deposits',
  INVESTMENT: 'investments',
  LOAN: 'loans',
}

export const getBankingProductsByType: Service<
  BankingProductsByTypeParams,
  ApiResponse<BankingProductsByTypeResponse>,
  Pick<AxiosRequestConfig, 'signal'>
> = async ({ api, params, config }) => {
  const { productType, interventionType } = params
  return api.get<ApiResponse<BankingProductsByTypeResponse>>(
    `/accounts/${productTypeUrlMap[productType]}`,
    { params: { interventionType }, ...config },
  )
}
